/**
 * The settings on this device.
 *
 * These are preferences, not account data: there is no server endpoint for
 * them, so they live in `localStorage` and every screen reads them fresh on
 * each render. A default only ever *prefills* a control - the stored value is
 * used when it is one of the server's current options, and ignored otherwise.
 */

export interface LocalSettings {
  recognitionMode: string | null;
  containerKind: string | null;
}

const KEY = 'unsorted.settings';

const clean = (value: unknown): string | null =>
  typeof value === 'string' && value !== '' ? value : null;

export function loadSettings(): LocalSettings {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (raw === null) return { recognitionMode: null, containerKind: null };
    const parsed: unknown = JSON.parse(raw);
    if (parsed === null || typeof parsed !== 'object') return { recognitionMode: null, containerKind: null };
    const record = parsed as Record<string, unknown>;
    return { recognitionMode: clean(record['recognitionMode']), containerKind: clean(record['containerKind']) };
  } catch {
    // Private mode, or storage refused: defaults are the setting.
    return { recognitionMode: null, containerKind: null };
  }
}

export function saveSettings(settings: LocalSettings): void {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(settings));
  } catch {
    // Losing a preference is not worth failing a screen over.
  }
}
